import React from 'react';

const TextGrid = ({ answerArray }) => {
  return (
    <div className="grid-container">
      {answerArray.map((answer, index) => (
        <div 
          key={index} 
          className="grid-item"
          style={{ backgroundColor: answer.color }} 
        >
          {answer.name}
        </div>
      ))}
    </div>
  );
};

export default TextGrid;
